import React from "react";
import "./notFound.css";

import Header from "../../common_components/Header";
import Footer from "../../common_components/Footer";
import { ReactComponent as SVG } from "./404.svg";

function NotFound() {
  return (
    <div>
      <Header />
      <div className="notfound">
        <SVG />
      </div>
      <Footer />
    </div>
  );
}

export default NotFound;
